import { CircleInfoSolidIcon } from "@elixir/icons";
import { useQueueWorkflowStore } from "@elixir/stores";
import { InputField } from "ui";

const NamingView = () => {
  const viewName = useQueueWorkflowStore((state) => state.viewName);
  const setViewName = useQueueWorkflowStore((state) => state.setViewName);

  return (
    <div className="dr-p-16 dr-flex dr-flex-col dr-gap-y-16">
      <p className="HeadlineBold">Enter the name for your view</p>
      <InputField
        placeholder="View name"
        onChange={(e) => {
          const sanitizedName = e.target.value;
          setViewName(sanitizedName);
        }}
        value={viewName}
      />
      <div className="dr-rounded-12 dr-p-16 dr-bg-darwin-touch-neutral-50">
        <div className="dr-flex dr-flex-row dr-gap-x-24">
          {/* <div
            className="dr-rounded-6 dr-h-129 dr-min-w-400"
            style={{ backgroundColor: "#E5E4E4" }}
          /> */}
          <div className="dr-flex dr-flex-col dr-gap-y-4">
            <CircleInfoSolidIcon className="w-13 h-14 dr-text-darwin-touch-neutral-600" />
            <p className="SubheadlineBold">
              Custom queues can be used to see the relevant patients at your
              workstation.
            </p>
            <p className="BodyRegular dr-italic dr-text-darwin-touch-neutral-600">
              Eg. At a reception desk, the staff might want to see all the
              patients in the queue while at the the nursing desk, they only
              want to see the patients that have been assigned to them. Use
              filters customise the queue for each workstation.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NamingView;
